export const SET_LBO_DASHBOARD = "SET_LBO_DASHBOARD";
export const SET_DCF_ANALYSIS = "SET_DCF_ANALYSIS";
export const SET_DEBTPANEL = "SET_DEBTPANEL";
export const SET_DCF_VALUATION = "SET_DCF_VALUATION";